// this file is generated by update_shopify_store_data.py at 2026-03-18 20:33:56.507982
var courses = [];